(()=>{'use strict';
 const panel=document.getElementById('walko-consent');if(!panel)return;
 const status=panel.querySelector('[data-walko-consent-status]'),details=panel.querySelector('#walko-consent-details');
 const buttons=[...panel.querySelectorAll('button')];let privacy,pending=false;
 const keys=['analytics','marketing','preferences'];
 const field=k=>panel.querySelector('[name="walko-cookie-'+k+'"]');
 const reflect=()=>{const consent=privacy.currentVisitorConsent();keys.forEach(k=>field(k).checked=consent[k]==='yes');};
 const show=()=>{panel.hidden=false;status.textContent='';if(privacy)reflect();};
 const save=consent=>{
  if(pending||!privacy)return;
  pending=true;buttons.forEach(b=>b.disabled=true);status.textContent='Enregistrement…';
  // Only this user-initiated handler records a choice. No direct cookie manipulation.
  privacy.setTrackingConsent(consent,result=>{
   pending=false;buttons.forEach(b=>b.disabled=false);
   if(result?.error){status.textContent='Votre choix n’a pas été enregistré. Réessayez.';return;}
   const actual=privacy.currentVisitorConsent();
   if(keys.some(k=>actual[k] !== (consent[k]?'yes':'no'))){status.textContent='Votre choix n’a pas été confirmé. Réessayez.';return;}
   panel.hidden=true;status.textContent='';
   // Reload after a decline/revocation so already initialized optional scripts are stopped.
   if(!consent.marketing||!consent.analytics)location.reload();
  });
 };
 buttons.forEach(b=>b.addEventListener('click',()=>{
  const action=b.dataset.walkoConsent;
  if(action==='custom'){details.hidden=!details.hidden;b.setAttribute('aria-expanded',String(!details.hidden));return;}
  const consent={};keys.forEach(k=>consent[k]=action==='accept'||(action==='save'&&field(k).checked));
  consent.sale_of_data=consent.marketing;save(consent);
 }));
 document.querySelectorAll('[data-walko-consent-open]').forEach(b=>b.addEventListener('click',()=>{show();panel.querySelector('button').focus();}));
 buttons.forEach(b=>b.disabled=true);
 if(!window.Shopify?.loadFeatures){show();status.textContent='Les choix de cookies sont momentanément indisponibles. Rechargez la page.';return;}
 window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
  if(error){show();status.textContent='Les choix de cookies sont momentanément indisponibles. Rechargez la page.';return;}
  privacy=Shopify.customerPrivacy;buttons.forEach(b=>b.disabled=false);reflect();
  const consent=privacy.currentVisitorConsent();
  if(keys.some(k=>consent[k]==='')&&!document.getElementById('shopify-pc__banner'))show();
 });
})();
